'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdBluetoothDisabled = function MdBluetoothDisabled(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 30.3l3.2-3.1-3.2-3.2v6.3z m-12.6-23.7l24.4 24.4-2.4 2.4-3.8-3.9-7.2 7.1h-1.6v-12.6l-7.7 7.6-2.3-2.3 9.3-9.3-11.1-11z m12.6 3.1v5.4l-3.2-3.4v-8.3h1.6l9.5 9.4-5 5.1-2.4-2.4 2.7-2.7z' })
        )
    );
};

exports.default = MdBluetoothDisabled;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/bluetooth-disabled.js
// module id = 1285
// module chunks = 168707334958949